import { Box, Button, Flex, Loader, ScrollArea, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { EventOverview } from 'src/meetings/components/EventOverview';
import { EventsList } from 'src/meetings/components/EventsList';
import { PastEventCard } from 'src/meetings/components/PastEventCard';
import { useCalendarEvents } from 'src/meetings/hooks/useCalendarEvents';
import { CalendarEvent } from 'src/meetings/models';
import { useFlags } from 'src/feature-flags/FlagsHook';

type Props = {
  selectedEvent: CalendarEvent | undefined;
  onCloseEvent: () => void;
};

export const EventDetailPanel = ({ selectedEvent, onCloseEvent }: Props) => {
  const { flagEnabledTranscriptionOnClientCreation } = useFlags();
  const { events, hasNextPage, fetchNextPage, isFetchingNextPage, isLoading } = useCalendarEvents({
    pastOrUpcoming: 'PAST',
    clientMeetingsOnly: !flagEnabledTranscriptionOnClientCreation,
    clientMeetingsAndWithRecordingOnly: flagEnabledTranscriptionOnClientCreation,
  });

  if (selectedEvent) {
    return (
      <Box p="lg">
        <EventOverview key={selectedEvent.id} event={selectedEvent} onClose={onCloseEvent} />
      </Box>
    );
  }

  return (
    <>
      <Text size="lg" fw={FONT_WEIGHTS.semibold} c="gray.10" mb="md" p="lg" pb={0}>
        Past client events
      </Text>
      <Box style={{ flex: 1, minHeight: 0 }}>
        <ScrollArea h="100%" px="lg">
          {isLoading ? (
            <Flex py={'lg'} justify={'center'}>
              <Loader />
            </Flex>
          ) : (
            <>
              <EventsList
                events={events}
                emptyMessage="Once a meeting ends, its recording and notes will appear here."
                renderCard={event => <PastEventCard event={event} />}
                order={'desc'}
              />
              {hasNextPage && (
                <Box ta="center" mt="md" mb="md">
                  <Button
                    variant="outline"
                    onClick={() => fetchNextPage()}
                    disabled={isFetchingNextPage}
                  >
                    {isFetchingNextPage ? 'Loading more...' : 'Load More'}
                  </Button>
                </Box>
              )}
            </>
          )}
        </ScrollArea>
      </Box>
    </>
  );
};
